"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FourthCurrentStep = void 0;
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const atome_1 = require("../../../components/atome");
const GlobalStyles_1 = require("../../../helper/GlobalStyles");
const Dashboard_style_1 = require("./Dashboard.style");
const FourthCurrentStep = (props) => {
    const { userInformation, scrollToAktuel } = props;
    return (react_1.default.createElement(react_native_1.View, { onLayout: event => {
            const layout = event.nativeEvent.layout;
            scrollToAktuel(layout.x, layout.y, layout.width, layout.height / 2, false);
        } },
        react_1.default.createElement(atome_1.Text, { style: [Dashboard_style_1.styles.heading3, GlobalStyles_1.globalStyles.marginTop25] }, "Ihre Videosprechstunde"),
        react_1.default.createElement(atome_1.Text, { style: [Dashboard_style_1.styles.text] }, "Ihre Videosprechstunde wurde gebucht."),
        react_1.default.createElement(react_native_1.View, { style: [
                GlobalStyles_1.globalStyles.row,
                Dashboard_style_1.styles.appointmentContainer,
                Dashboard_style_1.styles.mobileCalendar,
                GlobalStyles_1.globalStyles.alignCenter,
            ] },
            react_1.default.createElement(react_native_1.View, { style: [GlobalStyles_1.globalStyles.marginLeft25] },
                react_1.default.createElement(atome_1.Icon, { icon: 'calendar', size: 60 }),
                react_1.default.createElement(atome_1.Text, { style: [
                        Dashboard_style_1.styles.text,
                        GlobalStyles_1.globalStyles.textBold,
                        GlobalStyles_1.globalStyles.positionAbsolute,
                        Dashboard_style_1.styles.heading2,
                        Dashboard_style_1.styles.appointmentDay,
                    ] }, new Date(userInformation.appointment[userInformation?.appointment?.length - 1].startDate)
                    .getDate()
                    .toLocaleString('de-DE', {
                    minimumIntegerDigits: 2,
                }))),
            react_1.default.createElement(react_native_1.View, { style: [
                    GlobalStyles_1.globalStyles.flex2,
                    GlobalStyles_1.globalStyles.marginLeft10,
                ] },
                react_1.default.createElement(atome_1.Text, { style: [
                        Dashboard_style_1.styles.containerHeader,
                        GlobalStyles_1.globalStyles.width100,
                    ] }, new Date(userInformation.appointment[userInformation?.appointment?.length - 1].startDate).toLocaleDateString('de-DE', {
                    day: '2-digit',
                    month: 'long',
                    year: 'numeric',
                }) +
                    ' um ' +
                    new Date(userInformation?.appointment[userInformation?.appointment?.length - 1].startDate).toLocaleTimeString('de-DE', {
                        hour: '2-digit',
                        minute: '2-digit',
                    }) +
                    ' Uhr'),
                react_1.default.createElement(atome_1.Text, { style: [Dashboard_style_1.styles.containerText] },
                    "Arzt: ",
                    userInformation.appointment[0].doctorTitle,
                    ' ',
                    userInformation.appointment[userInformation?.appointment?.length - 1].doctorName))),
        react_1.default.createElement(atome_1.Text, { style: [Dashboard_style_1.styles.text] }, "Bitte erscheinen Sie f\u00FCnf Minuten vor dem Termin in der Videosprechstunde."),
        react_1.default.createElement(react_native_1.View, { style: [GlobalStyles_1.globalStyles.flex2] },
            react_1.default.createElement(react_native_1.TouchableOpacity, { style: [
                    Dashboard_style_1.styles.button,
                    GlobalStyles_1.globalStyles.marginTop25,
                    Dashboard_style_1.styles.height40,
                ] },
                react_1.default.createElement(atome_1.Link, { href: `https://esprechstunde.net/termin/${userInformation.appointment[userInformation?.appointment?.length - 1].esprechstundeCode}` },
                    react_1.default.createElement(atome_1.Text, { style: [Dashboard_style_1.styles.buttonText] }, "Zur Videosprechstunde"))))));
};
exports.FourthCurrentStep = FourthCurrentStep;
